import useI18n from "@/hooks/useI18n";
import { TAG_CHECKOUT_URL } from "@/domain/scrapers/concessionaires";

const BENEFIT_KEYS = [
  "pages:home:tagIncentiveBenefitDiscount",
  "pages:home:tagIncentiveBenefitAutoPay",
  "pages:home:tagIncentiveBenefitCoverage",
  "pages:home:tagIncentiveBenefitFines",
] as const;

export default function TagIncentiveCard() {
  const { t } = useI18n();

  return (
    <div className="w-full bg-foreground border border-border rounded-2xl p-6 flex flex-col gap-3">
      <div className="flex gap-2">
        <span className="bg-primary text-white text-sm font-bold font-primary px-1 rounded leading-[1.4]">
          {t("pages:home:tagIncentiveNoMonthlyFee")}
        </span>
        <span className="bg-primary text-white text-sm font-bold font-primary px-1 rounded leading-[1.4]">
          {t("pages:home:tagIncentiveNoFee")}
        </span>
      </div>

      <h3 className="text-2xl font-extrabold font-primary text-text tracking-[-0.5px] leading-[1.2]">
        {t("pages:home:tagIncentiveTitle")}
      </h3>

      <div className="w-full h-px bg-border" />

      <ul className="flex flex-col gap-3">
        {BENEFIT_KEYS.map((key) => (
          <li key={key} className="flex items-center gap-3">
            <img
              src="/svg/icon-check-green.svg"
              alt=""
              width={24}
              height={24}
              className="w-6 h-6 shrink-0"
            />
            <p className="text-sm font-medium font-primary text-text leading-[1.3]">
              {t(key)}
            </p>
          </li>
        ))}
      </ul>

      <div className="flex items-center gap-3 mt-1">
        <img
          src="/svg/icon-security.svg"
          alt=""
          width={22}
          height={24}
          className="w-[22px] h-6 shrink-0"
        />
        <p className="text-sm font-medium font-primary text-text leading-[1.3]">
          {t("pages:home:tagIncentiveBenefitSafe")}
        </p>
      </div>

      <a
        href={TAG_CHECKOUT_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-2 w-full h-[60px] bg-primary text-white rounded-theme-large font-primary text-base font-medium flex items-center justify-center"
      >
        {t("pages:home:tagIncentiveCta")}
      </a>
    </div>
  );
}
